
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Puzzle } from "lucide-react";

export const OnlineActivitiesSection = () => {
  const onlineActivities = [
    {
      title: "Virtual Beach Cleanup",
      description: "Help Bobo & Teedee® clean up Seven Mile Beach in this interactive online activity!",
      type: "Environmental",
      color: "#2563eb", // Darker blue
      shadowColor: "#3b82f6"
    },
    {
      title: "Cayman Culture Memory Match",
      description: "Match traditional Cayman foods, landmarks, and cultural items in this memory game.",
      type: "Culture",
      color: "#059669", // Darker green
      shadowColor: "#10b981"
    },
    {
      title: "Kindness Story Builder",
      description: "Create your own kindness story using characters and scenarios from the islands.",
      type: "Creative",
      color: "#7c3aed", // Darker purple
      shadowColor: "#8b5cf6"
    }
  ];

  return (
    <section className="py-16 bg-white/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">Interactive Online Activities</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Play these fun online games and activities right in your web browser!
          </p>
          <p className="text-sm text-gray-500 mt-4">*Coming Soon - Currently in development</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {onlineActivities.map((activity, index) => (
            <Card key={index} className="text-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white/90 backdrop-blur-sm border-2"
                  style={{ borderColor: `${activity.shadowColor}33` }}>
              <CardContent className="p-8">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto"
                     style={{ backgroundColor: `${activity.shadowColor}33` }}>
                  <Puzzle className="h-8 w-8" style={{ color: activity.shadowColor }} />
                </div>
                <h3 className="text-xl font-bold mb-4" style={{ color: activity.shadowColor }}>
                  {activity.title}
                </h3>
                <p className="text-gray-600 mb-6">{activity.description}</p>
                <Button 
                  disabled
                  className="text-white font-bold px-8 py-4 rounded-lg cursor-not-allowed transition-all duration-300 shadow-lg disabled:opacity-100"
                  style={{ 
                    backgroundColor: activity.color,
                    boxShadow: `0 8px 25px ${activity.shadowColor}40`
                  }}
                >
                  Coming Soon
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
